import styled from 'styled-components';

interface AlertBoxProps {
  children: React.ReactNode;
  variant?: 'warning' | 'success' | 'error' | 'info';
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export function AlertBox({
  children,
  variant = 'success',
  icon,
  action,
}: AlertBoxProps) {
  return (
    // `role="alert"` is set here rather than at call sites: every use is a
    // banner, and one that appears after a form submit is only announced to
    // screen readers from a live region.
    <StyledAlertBox role="alert" $variant={variant}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <ContentWrapper>{children}</ContentWrapper>
      {action && <ActionWrapper>{action}</ActionWrapper>}
    </StyledAlertBox>
  );
}

const StyledAlertBox = styled.div<{
  $variant: 'warning' | 'success' | 'error' | 'info';
}>`
  align-items: center;
  background: var(--white);
  border-left: 8px solid
    ${(props) => {
      switch (props.$variant) {
        case 'warning':
          return 'var(--orange)';
        case 'error':
          return 'var(--wbs-red)';
        case 'success':
          return 'var(--green)';
        default:
          return 'var(--blue)';
      }
    }};
  border-radius: 5px;
  box-shadow: var(--shadow-sm);
  color: var(--black);
  display: flex;
  font-family: var(--raleway);
  font-size: 15px;
  gap: 12px;
  margin-bottom: 26px;
  padding: 12px 24px;
`;

const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
`;

const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const ActionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
`;
